import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import MouseOverEditDiv from '../../../../tc-ui/mouse-over-edit-div';
import AddItemCard from '../../../generic-components/add-item-card/add-item-card';
import EditButton from '../../../generic-components/edit-button';
import HelperLink from '../helper-link';
import moment from 'moment';
import R from 'ramda';

const propTypes = {
  supplierEditable: PropTypes.bool,
  blackouts: PropTypes.array,
  openAddEditContractDialog: PropTypes.func,
  classes: PropTypes.object,
};
class RightTwoBlackouts extends Component {
  shouldComponentUpdate(nextProps) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps));
  }
  render() {
    const { blackouts, supplierEditable, openAddEditContractDialog, classes = {} } = this.props;
    const startDate = ({ startDate: date }) => (date ? new Date(date) : '');
    const endDate = ({ endDate: date }) => (date ? new Date(date) : '');
    const format = date => (date ? moment.utc(date).format('D MMM YYYY') : '');
    const editBlackoutsFn = () =>
      openAddEditContractDialog({
        type: 'blackouts',
        title: 'Edit Blackout Days',
      });
    return (
      <div id="blackouts" className={classes.main}>
        <HelperLink
          labelText="BLACKOUT DAYS"
          value="blackouts"
          showSync={Boolean(blackouts && blackouts.length)}
          labelStyle={{ marginBottom: '12px', display: 'block' }}
        />
        {blackouts && blackouts.length ? (
          <MouseOverEditDiv
            editable={supplierEditable}
            hintOnRight
            singleLineTitle
            regularDiv={!R.all(R.prop('startDate'), blackouts)}
            actionButtons={
              blackouts && blackouts.length ? <EditButton onEdit={editBlackoutsFn} /> : undefined
            }
            className={classes[`main`]}
          >
            {blackouts
              // .sort((a, b) => (startDate(a) > startDate(b)) ? 1 : -1) COMMENT OUT because need to use the correct classes
              .map((blackout, index) => {
                const dates =
                  format(startDate(blackout)) === format(endDate(blackout)) ? (
                    <span className={classes[`${index}-endDate`]}>
                      {format(startDate(blackout))}
                    </span>
                  ) : (
                    <span>
                      <span className={classes[`${index}-startDate`]}>
                        {format(startDate(blackout))}
                      </span>
                      <span className={classes[`${index}-endDate`]}>
                        {blackout.endDate ? `- ${format(endDate(blackout))}` : ''}
                      </span>
                    </span>
                  );
                return (
                  <div
                    style={{ marginBottom: '12px' }}
                    key={index}
                    className={classes[`${index}-blackout`]}
                  >
                    <small className={classes[`${index}-name`]}>
                      {blackout.name ? blackout.name.toUpperCase() : ''}
                    </small>
                    {dates ? (
                      <div>{dates}</div>
                    ) : (
                      <div
                        style={{ color: '#f44336', cursor: 'pointer' }}
                        onClick={editBlackoutsFn}
                      >
                        Complete Blackout Dates
                      </div>
                    )}
                  </div>
                );
              })}
          </MouseOverEditDiv>
        ) : (
          <AddItemCard
            text="Add blackout days"
            onClick={() =>
              openAddEditContractDialog({
                type: 'blackouts',
                title: 'Add Blackout Days',
              })
            }
            editable={supplierEditable}
          />
        )}
      </div>
    );
  }
}

RightTwoBlackouts.propTypes = propTypes;

const mapStateToProps = ({ contracting }, { reducerName, blackouts }) => {
  if (blackouts) return { blackouts };
  return {
    blackouts: contracting[reducerName].getIn(['rightSideContent', 'blackouts'])
      ? contracting[reducerName].getIn(['rightSideContent', 'blackouts']).toJS()
      : [],
  };
};
export default connect(mapStateToProps)(RightTwoBlackouts);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/product/right-column/right-two-blackouts.jsx